import {IconButton, ListItem, ListItemSecondaryAction, ListItemText} from '@mui/material';
import {KeyboardArrowRight, Warning} from '@mui/icons-material';
import React from 'react';
import styled from 'styled-components';
import {FONTS} from '@fupa/fupa-uikit';
import {useTheme} from '@mui/styles';
import {useHistory} from 'react-router';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';

const Hint = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.color};
  font-size: ${FONTS['14']};
`;

const HintText = styled.span`
  margin-left: 0.5rem;
`;

const DeviceManagementLinkRow = () => {
  const {palette} = useTheme();
  const history = useHistory();
  const {notificationPermission, messagingDeviceToken, devices, pushSupport} = useSelector(selectCurrentUser);

  const navigateToDeviceManagement = () => {
    history.push('/my/following/devices');
  };

  const deviceStatus = () => {
    if (messagingDeviceToken) {
      return null;
    }

    const deviceSubscribed = devices.find(device => device.id === messagingDeviceToken);
    let text = '';
    if (!pushSupport) {
      text = 'nicht unterstützt';
    } else if (notificationPermission === 'granted' && !deviceSubscribed) {
      //FIXME: Use Case not working atm due to fetching FCM-Token on initialization -> Iteration #5
      text = 'nicht registriert';
    } else {
      const status = {
        default: 'nicht registriert',
        deactivated: 'nicht registriert',
        denied: 'blockiert',
      };
      text = status[notificationPermission];
    }

    return (
      <Hint color={palette.warning.main}>
        <Warning color='inherit' fontSize='inherit' />
        <HintText>Aktuelles Gerät {text}.</HintText>
      </Hint>
    );
  };

  return (
    <ListItem>
      <ListItemText id='switch-push-notifications' primary='Geräte verwalten' secondary={deviceStatus()} />
      <ListItemSecondaryAction>
        <IconButton edge='end' onClick={navigateToDeviceManagement} size='large'>
          <KeyboardArrowRight color={'action'} />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export {DeviceManagementLinkRow};
